// extracted by mini-css-extract-plugin
export var borderRadius = "_55-4";
export var large = "_55-3";
export var logoContainer = "_55-0";
export var nameLogo = "_55-2";
export var small = "_55-1";